/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.DeleteVideoNoteAction.REQUEST_DELETEVIDEONOTE:
      return {
        ...state,
    };
    case actions.DeleteVideoNoteAction.DELETEVIDEONOTE_RECEIVED:
          return{
      ...state,
    };

    default:
      return state;
  }
};

export default reducer;
